import React from 'react';
import './Button.css';

function Button({ label = '', secondary = false, onClick, className = '' }) {
    return (
        <div
            onClick={onClick}
            className={
                secondary
                    ? `app-button shadow ${className}`
                    : `app-button-primary shadow ${className}`
            }
        >
            {label}
        </div>
    );
}

export default Button;
